<template>
	<div class="ssoModuleScndFilter" @keyup.enter="doEnterThings()">
		<!-- <h2>ФИЛЬТР ВТОРИЧКИ</h2> -->
		<card class="majorFilter-card">
			<div class="majorFilter row px-3">
				<div class="firstFilter-row"> 
					<!--
					<div class="mr-3 mb-2">
						<el-select
							class="col-md px-0 select-primary"
							v-model="objFilterData.market.value" 
							placeholder="Купить/продать"
							size="large"
						>
							<el-option
								class="select-primary"
								v-for="item in objFilterData.market.options"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							>
							</el-option>
						</el-select>
					</div>
					-->
					<div class="mb-2">
						<ReSelectCascadeObjCategory v-model="objFilterData.JSON_houseType.value"/>
					</div>
					<div class="price-search mr-3 mb-2">
						<ReInputRange class="mb-3" v-model="objFilterData.price.value" placeholder="Цена от|до" inputType="money"/>
					</div>
					<div class="base-search col-md-4 px-0 mr-3" :class="[{'d-none':bInObjectPage}]">
						<!--
						<ReInputSearchDropType 
							:disabled="bInObjectPage"
							name="BigSearch"
							placeholder="Поиск по городу, адресу, метро, району, ж/д, шоссе"
							:MinTxtLen="2"
							v-model="BigSearch"
							:objApiMethod="{obj:'SecondObj' ,flt:{name:''}}"
							strApiMethodKey="name"
							strApiMethod="GET_ADDR"
							v-on:change="OnBigSearch"
						/>
						-->
						<base-input
							placeholder="Поиск по городу, адресу, метро, району, шоссе"
							addon-left-icon="tim-icons icon-zoom-split"
							v-model="objFilterData.addr.value"
							autocomplete="off"
						>
						</base-input>
					</div>
					<div class="mr-3 mb-2">
						<el-select
							class="col-md px-0 select-primary"
							v-model="objFilterData.salesTypeId.value" 
							placeholder="Тип клиента"
							size="large"
							clearable
						>
							<el-option
								class="select-primary"
								v-for="item in objFilterData.salesTypeId.options"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							>
							</el-option>
						</el-select>
					</div>
					<div class="mr-3 mb-2">
						<el-select
							class="col-md px-0 select-primary"
							v-model="objFilterData.operation_type.value" 
							placeholder="Тип операции"
							size="large"
							clearable
						>
							<el-option
								class="select-primary"
								v-for="item in objFilterData.operation_type.options"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							>
							</el-option>
						</el-select>
					</div>					
					<div class="mr-3 mb-2">
						<el-select						
							class="col-md px-0 select-primary"						
							filterable
							placeholder="Источник объявления"
							size="large"
							v-model="objFilterData.sourceId.value" 
							clearable
						>
							<el-option
								class="select-primary long-select"
								v-for="option in objFilterData.sourceId.options"
								:key="option.label"
								:label="option.label"
								:value="option.value"
							>
							</el-option>
						</el-select>
					</div>
					
					<div class="mr-3 mb-2">
						<el-select						
							class="col-md px-0 select-primary overflow-overlay"						
							filterable
							clearable
							placeholder="Ячейка"
							:multiple="true"
							size="large"
							v-model="objFilterData.cellId.value" 
						>
							<el-option
								class="select-primary long-select"
								v-for="option in objFilterData.cellId.options"
								:key="option.label"
								:label="option.label"
								:value="option.value"
							>
							</el-option>
						</el-select>
					</div>
					<template v-if="objFilterData.sourceId.value == $GVO.server_config.object_source_id">
						<div class="mr-3 mb-2" >
							<ReSearchStaffClients 
								placeholder="ФИО сотрудника"
								placeholder_otdel="Название отдела"
								v-model="objFilterData.structure.value"
								:objApiMethod="{'obj':'staff','flt':{'fio':''}}"
								:strApiMethodKey="'fio'"
								:objApiMethod_otdel="{'obj':'structures','flt':{'name':''}}"
								:strApiMethodKey_otdel="'name'"
								:rb_options="objFilterData.structure.rb_options"
								v-on:change="OnAjaxListSearch"
								
							/>
						</div>
					</template>

					<div class="allFilters">
						<base-button @click="ShowFilter()" type="primary" simple ><i class="d-inline-block tim-ic ic-filter mr-2"></i><span>Все фильтры</span><span class="badge badge-pill badge-primary ml-2" v-if="optCount != ''">{{optCount}}</span></base-button>
					</div>
					<div class="applyFilter">
						<base-button @click="OnFilterApply()" type="success">Применить</base-button>
					</div>

				</div>
				<div class="firstFilter-row filter-tags mt-2">
					<el-tag
						v-for="tag in filterTags"
						:key="tag.param_id"
						size="small"
						:closable="true"
						:close-transition="false"
						@close="handleClose(tag)"
						:type="'primary'"
					>
					{{ tag.name }}
					</el-tag>
					<span v-if="optCount != ''" class="el-tag el-tag--danger el-tag--small el-tag--light"> Сбросить всё <i class="el-tag__close el-icon-close" @click="OnFilterReset()"></i></span>
				</div>

			</div>	

			<hr v-show="this.bShowFilter">

			<div class="moreFilter mt-3" v-show="bShowFilter">
				<div class="filter-row">
					<div class="col-md-4 col-sm-6 pl-0">
						<div class="mr-3 mb-2 flat-corp-width"> 
							<h5 class="col-form-label col-md-12">Этаж</h5>
							<ReInputRange  v-model="objFilterData.floor.value" placeholder="от|до" inputType="number"/>
							<base-checkbox v-model="objFilterData.dfoorlast.value" inline>Последний</base-checkbox>
							<base-checkbox v-model="objFilterData.dfloornotfst.value" inline>Кроме первого</base-checkbox>
							<base-checkbox v-model="objFilterData.dfloornotlst.value" inline>Кроме последнего</base-checkbox>
						</div>
						<div class="mr-3 mb-2 flat-corp-width">
							<el-select						
								class="col-md px-0 select-primary overflow-overlay"						
								filterable
								clearable
								placeholder="Тип дома"
								:multiple="true"
								size="large"
								v-model="objFilterData.buildingType.value" 
							>
								<el-option
									class="select-primary long-select"
									v-for="option in objFilterData.buildingType.options"
									:key="option.label"
									:label="option.label"
									:value="option.value"
								>
								</el-option>
							</el-select>
						</div>

						<div class="mr-3 mb-2 flat-corp-width"> 
							<h5 class="col-form-label col-md-12">До метро</h5>
							<base-input
								placeholder="км"
								v-model="objFilterData.fromSubway.value"
								type="number"
								autocomplete="off"
							></base-input>
						</div>

						
					</div>
					

					<div class="col-md-4 col-sm-6 pl-0">
						<div class="mr-3 mb-2 flat-corp-width"> <!--h5 class="col-form-label col-md-12">Площади</h5-->
							<h5 class="col-form-label col-md-12"> Площадь общая</h5>
							<ReInputRange class="mb-2" v-model="objFilterData.area.value" placeholder="от|до" inputType="number"/>
							<h5 class="col-form-label col-md-12">Площадь кухни</h5>
							<ReInputRange class="mb-2" v-model="objFilterData.kitchenSpace.value" placeholder="от|до" inputType="number"/>
							<h5 class="col-form-label col-md-12" v-if="objFilterData.JSON_houseType.value.houseTypeList == '3'">Площадь комнаты</h5>
							<ReInputRange class="mb-3" v-model="objFilterData.livingSpace.value" placeholder="от|до" inputType="number" 
							v-if="objFilterData.JSON_houseType.value.houseTypeList == '3'"/>
							<!--
							<h5 class="col-form-label col-md-12">Комнат в квартире (активно только при поиске “Комната”)</h5>
							<base-checkbox v-model="objFilterData.roomnum2.value" inline>2</base-checkbox>
							<base-checkbox v-model="objFilterData.roomnum3.value" inline>3</base-checkbox>
							<base-checkbox v-model="objFilterData.roomnum4.value" inline>4</base-checkbox>
							<base-checkbox v-model="objFilterData.roomnum5more.value" inline>5+</base-checkbox>
							-->
						</div>
						<!-- <div class="col-md-4 col-sm-6 pl-0"></div> -->
						<div class="mr-3 mb-2 flat-corp-width"> 
							<h5 class="col-form-label col-md-12">Год ввода в эксплуатацию</h5>
							<!-- <base-input
								placeholder="год"
								v-model="objFilterData.houseStartYear.value"
								type="number"
								autocomplete="off"
							></base-input> -->
							<ReInputRange class="mb-3" v-model="objFilterData.houseStartYear.value" placeholder="Год от|до" inputType="text"/>
						
					</div>
					</div>		

					<div class="col-md-4 col-sm-6 pl-0">
						<div class="mr-3 mb-2 flat-corp-width">
							<h5 class="col-form-label col-md-12">Дата публикации</h5>
							<el-select
								class="overflow-overlay col-md px-0 select-primary mb-3 "
								v-model="objFilterData.creationDate.value" 
								placeholder="Дата публикации"
								size="large"
								clearable
							>
								<el-option
									class="select-primary"
									v-for="item in objFilterData.creationDate.options"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								>
								</el-option>
							</el-select>
						</div>
						<div class="base-search id-search px-0 mr-3">
							<base-input
								placeholder="Поиск ID"
								addon-left-icon="tim-icons icon-zoom-split" 
								v-model="objFilterData.id.value" 
								autocomplete="off"
							>
							</base-input>
						</div>
						
						
						<div v-if="objFilterData.sourceId.value == $GVO.server_config.object_source_id" class="base-search internalId-search px-0 mr-3">
							<base-input
								placeholder="Поиск коду объекта в базе"
								addon-left-icon="tim-icons icon-zoom-split" 
								v-model="objFilterData.internalId.value" 
								autocomplete="off"
							>
							</base-input>
						</div>
					</div>

				</div>
			</div>
		</card>
		<div class="mb-4">
				<div class="row justify-content-end mx-0">
					<el-select						
						class="col-md col-xl-4 px-0 select-primary  overflow-overlay"
						placeholder="Сортировка по умолчанию"
						size="large"
						v-model="objFilterData.dSortType.value"
						@change="OnFilterApply()"
					>
						<el-option
							class="select-primary long-select"
							v-for="option in objFilterData.dSortType.options"
							:key="option.value"
							:label="option.label"
							:value="option.value"
						>
						</el-option>
					</el-select>
				</div>
		</div>
	</div>
</template>
<script>

import { Select, Option } from 'element-ui';
import { BaseCheckbox, /*BaseRadio, BaseSwitch*/ } from 'src/components/index';
// import {eventEmitter} from "src/plugins/globalComponents.js";
// import ReFromMetro from "src/our_components/ReFromMetro.vue";
import ReInputRange from "src/our_components/ReInputRange.vue";
import { Tag } from 'element-ui';
// import ReInputSearchDropType from 'src/our_modules/SearchSendObjects/ReInputSearchDropType.vue';
import ReSelectCascadeObjCategory from 'src/our_components/ReSelectCascadeObjCategory.vue';
import ReSearchStaffClients from 'src/our_components/ReSearchStaffClients.vue';

export default {
	name: 'ssoModuleScndFilter',
	components: {
		[Option.name]: Option,
		[Select.name]: Select,
		BaseCheckbox,
		// BaseRadio,
		// BaseSwitch,
		// ReFromMetro,
		ReInputRange,
		[Tag.name]: Tag,
		// ReInputSearchDropType,
		ReSelectCascadeObjCategory,
		ReSearchStaffClients,
	},
	props: {
		value: String,
		complex_corp_options: {
			type: Array,
			default: function(){return [];}
		},
		
	},
	data() {
		return {
			cellIdOptions:[],
			bShowFilter: false,
			BigSearch: {inputText: '', selectedVal:''}, //поиск по городу и прочему. Вопрос про формат данных и их соответсвие с базой
			objGetParams: {},
			masExcludeParams: ['page','p','c2p','AddComplexMinFlatsBig','dSortOrder','dSortType','dSearchType','client_id','taskend_id','task_id','service_id'],
			optCount: '',
			filterTags:[],
			objFilterData: { 
				//Правила: 
				// 1) Имя свойсва - это параметр отправляем в GET метод АПИ; 
				// 2) одно свойство - одно поле/компонет. 
				// 3) В свойстве поле value привязывать к v-model поля/компонета. 
				// 4) Все поля/компонета должны уметь v-model

				salesTypeId:{value:'', catalog:'', options:[{value: '3',label: 'Собственник',},{value: '2',label: 'Агент'},{value: '1',label: 'Частное лицо'}], tagText:'Тип клиента', elementType: 'select', value_default: ''},
				sourceId:{value:'', catalog:'cat_objects_source', options:[], tagText:'Источник объявления', elementType: 'select', value_default: ''},
				operation_type:{value:'', catalog:'', options:[{value:'2', label: 'Продажа'},{value:'3', label:'Аренда'}], tagText:'Тип операции', elementType: 'select',value_default:''},
				cellId:{value:'', catalog:'', options:[], tagText:'Ячейка', elementType: 'select', value_default: ''},
				//-----
				id:{value:'', tagText:'ID', elementType: 'input', value_default: ''},
				internalId:{value:'', tagText:'Код в базе', elementType: 'input', value_default: ''},				
				// houseStartYear:{value:'', tagText:'год', elementType: 'input', value_default: ''},
				houseStartYear:{value:{min:'',max:''}, map_min:'houseStartYearmin', map_max:'houseStartYearmax', tagText:'Год', elementType: 'input-range', value_default: {min:'',max:''}},
				addr:{value:'', tagText:'Адрес', elementType: 'input', value_default: ''},
				//сверяться только по houses , НО не все объекты из ADS привязываются к домам что выкачали парсером - значит при выборе конкретного типа - может отсеяться куча "квартир"
				buildingType:{value:'', catalog:'', options:[{value: '0',label: 'Кирпичный',},{value: '1',label: 'Панельный'},{value: '2',label: 'Монолитный'}], tagText:'Тип дома', elementType: 'select', value_default: ''},
				//
				fromSubway:{value:'', tagText:'км', elementType: 'input', value_default: ''},
				creationDate:{value:'', catalog:'', options:[
					{value: '0',label: 'Неважно',},
					{value: '1',label: 'За месяц',},
					{value: '2',label: 'За неделю',},
					{value: '3',label: 'За сегодня',},
					{value: '4',label: 'За час',},
				], tagText:'Дата публицации', elementType: 'select', value_default: ''},

				//это уберётся потому что новый компонент из сот
				JSON_houseType:{value:{houseTypeList:'',houseRoomsList:'', }, tagText:'Тип жилья', elementType: 'select-objcat', value_default:{houseTypeList:'',houseRoomsList:'',}},

				price:{value:{min:'',max:''}, map_min:'pricemin', map_max:'pricemax', tagText:'Стоимость', elementType: 'input-range', value_default: {min:'',max:''}},
				area:{value:{min:'',max:''}, map_min:'areamin', map_max:'areamax', tagText:'Площадь общая', elementType: 'input-range', value_default: {min:'',max:''}},
				kitchenSpace:{value:{min:'',max:''}, map_min:'kitchenSpacemin', map_max:'kitchenSpacemax', tagText:'Площадь кухни', elementType: 'input-range', value_default: {min:'',max:''}},
				livingSpace:{value:{min:'',max:''}, map_min:'livingSpacemin', map_max:'livingSpacemax', tagText:'Жилая площадь', elementType: 'input-range', value_default: {min:'',max:''}},

				floor:{value:{min:'',max:''}, map_min:'dfloorfrom', map_max:'dfloorto', tagText:'Этаж', elementType: 'input-range', value_default: {min:'',max:''}},
				//опечатка dfloorlast
				dfoorlast:{value:false, tagText:'Этаж последний', elementType: 'checkbox', value_default: false},
				dfloornotfst:{value:false, tagText:'Кроме первого', elementType: 'checkbox', value_default: false},
				dfloornotlst:{value:false, tagText:'Кроме последнего', elementType: 'checkbox', value_default: false},

				dSearchType:{value:'flats', elementType: 'input-hidden', value_default: ''}, // flats||flatmap
				dSortType:{value:'dt_upde|d', catalog:'', options:[
					{value: 'dt_upd|d',label: 'По дате обновления (сначала новые)',},
					{value: 'dt_upd|a',label: 'По дате обновления (сначала старые)',},
					{value: 'dt_cre|d',label: 'По дате создания (сначала новые)',},
					{value: 'dt_cre|a',label: 'По дате создания (сначала старые)',},
					{value: 'price|a',label: 'По цене (сначала дешевле)',},
					{value: 'price|d',label: 'По цене (сначала дороже)',},
				], tagText:'Сортировка', elementType: 'select', value_default: ''},
				//dSortOrder:{value:'a', elementType: 'input-hidden', value_default: ''}, // a||d
				structure: {
					value: {'agent_id':'','otdel_id':'','isFired':''}, 
					tagText:'Объекты', 
					elementType: 'ajax-list-client', 
					rb_options: [{'name': '0', 'label': 'Все объекты'},{'name': '1', 'label': 'Мои объекты'}], 
					value_default: {'agent_id':'','otdel_id':'','isFired':''},
					catalog:'CAT_STAFF'
				}, //'elementGetParamMap'=>'agent_id|otdel_id|isFired',				
			},
			cat_objects: [],  
			cat_objects_category: [],
			objCurHouseTypes: {},
		};
	},
	computed: {
		
		dmaxprice(){
			return this.objFilterData.price.value.max;
		},
		dminprice(){
			return this.objFilterData.price.value.min;
		},
		
		bInObjectPage(){
			if(location.pathname.indexOf('/sso/objectscnd/') != -1) return true;
			return false;
		},
	},
	watch: {
		// dmaxprice(val){
		// 	val = this.$GVO.str_replace(' ','',val);
		// 	let number1 = this.$GVO.number_format(val,0,'.',' ');
		// 	if(number1 == 0 ){ number1= ''; }
		// 	this.objFilterData.price.value.max = number1;
		// },
		// dminprice(val){
		// 	val = this.$GVO.str_replace(' ','',val);
		// 	let number1 = this.$GVO.number_format(val,0,'.',' ');
		// 	if(number1 == 0 ){ number1= ''; }
		// 	this.objFilterData.price.value.min = number1;
		// },
		
	},
	methods: {
		findTag(tag){
			for (let i = 0; i < this.filterTags.length; i++) {
				const elTag = this.filterTags[i];
				if(/*elTag.name == tag.name && */elTag.param_id == tag.param_id) return i;
			}
			return -1;
		},
		translateTags(data){
			// let strValue = this.objFilterData[data.selectedType].value;
			// let masValue = strValue.split(';');

			// for (let i = 0; i < masValue.length; i++) {
			// 	masValue[i] = this.$GVO.GetCat(this.objFilterData[data.selectedType].catalog,masValue[i]).name;
			// }
			// strValue = masValue.join(';');
			// return strValue;

			let strValue = '';
			let masValue = [];
			if(data.selectedType == 'ajax-list-client'){
				data.selectedType = 'structure';
				if(this.objFilterData[data.selectedType].value.agent_id != ''){
					masValue.push(this.objFilterData[data.selectedType].value.agent_id);
				}
				if(this.objFilterData[data.selectedType].value.otdel_id != ''){
					masValue.push(this.objFilterData[data.selectedType].value.otdel_id);
					// console.log('translateTags', this.objFilterData[data.selectedType].value.otdel_id);
				}
				if(this.objFilterData[data.selectedType].value.isFired != ''){
					masValue.push(this.objFilterData[data.selectedType].value.isFired);
				}
			}else{
				strValue = this.objFilterData[data.selectedType].value;
				masValue = strValue.split(';');
			}
			for (let i = 0; i < masValue.length; i++) {
				masValue[i] = this.$GVO.GetCat(this.objFilterData[data.selectedType].catalog,masValue[i]).name;
				//для this.objFilterData['structure'] придумать что-то с каталогом для имён сотрудников и отделов
			}
			strValue = masValue.join(';');
			return strValue;
		},
		OnBigSearch(data){
			let masTmp = [];
			if(typeof this.objFilterData[data.selectedType] != 'undefined'){
				let strValue = this.translateTags(data);

				let tag = {name: `${this.objFilterData[data.selectedType].tagText}: ${strValue}`, param_id: data.selectedType};
				if(this.findTag(tag) != -1) this.filterTags.splice(this.findTag(tag), 1); // закрываем старый тег

				if(this.objFilterData[data.selectedType].value != ''){
					masTmp = this.objFilterData[data.selectedType].value.split(';');
				}
				masTmp.push(data.selectedVal);
				this.objFilterData[data.selectedType].value = masTmp.join(';');

				this.BigSearch.inputText='';
				strValue = this.translateTags(data);

				tag = {name: `${this.objFilterData[data.selectedType].tagText}: ${strValue}`, param_id: data.selectedType};
				//console.log(tag);
				this.filterTags.push(tag);
			}
		},
		handleClose(tag,bApply=true) { // переделать всё на this.$GVO.unlinkObject(this.objFilterData[tag.param_id].value_default)
			if(this.objFilterData[tag.param_id].elementType == 'input-range'){
				this.objFilterData[tag.param_id].value.min = '';
				this.objFilterData[tag.param_id].value.max = '';
			} else if(this.objFilterData[tag.param_id].elementType == 'checkbox'){
				this.objFilterData[tag.param_id].value = false;
			} else if(this.objFilterData[tag.param_id].elementType == 'select-objcat'){
				this.objFilterData[tag.param_id].value.houseTypeList = '';
				this.objFilterData[tag.param_id].value.houseRoomsList = '';
				this.objFilterData[tag.param_id].value.houseTypeName = '';
			} else if(this.objFilterData[tag.param_id].elementType == 'fromSubway'){
				this.objFilterData[tag.param_id].value = this.$GVO.unlinkObject(this.objFilterData[tag.param_id].value_default);
			} else if(this.objFilterData[tag.param_id].elementType == 'ajax-list-client'){
				this.objFilterData[tag.param_id].value = this.$GVO.unlinkObject(this.objFilterData[tag.param_id].value_default);
			} else {
				this.objFilterData[tag.param_id].value = '';
			}
			this.filterTags.splice(this.findTag(tag), 1);
			if(bApply) this.OnFilterApply();
		},
		setOptCount(data=false){ // тут не только считается количество параметров в фильтре. НО и отрисовка тегов
			if(!data){
				this.objGetParams = this.$GVO.GetAllGet();
			}else{
				this.objGetParams = data;
			}
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				let masKeys = Object.keys(this.objGetParams);
				//console.log('setOptCount_masKeys',masKeys);
				let iOptsCount = 0;
				this.filterTags = [];
				if(typeof this.masExcl != 'undefined'){
					this.masExcludeParams = [...this.masExcludeParams, ...this.masExcl];
				}
				for (let i = 0; i < masKeys.length; i++) {
					if(this.masExcludeParams.indexOf(masKeys[i]) === -1){									
						if(this.objGetParams[masKeys[i]] !== false && this.objGetParams[masKeys[i]] !== 'false'){
							//console.log('setOptCount_masKeys_i',masKeys[i]);
							let element = this.getFilterDataElement(masKeys[i]);
							if(typeof element === 'undefined') continue;
							//console.log('setOptCount_element',element);
							let bInTags = false;
							for (let iTag = 0; iTag < this.filterTags.length; iTag++) {
								if(this.filterTags[iTag].param_id == element.param_id){
									bInTags = true;
								}
							}
							if(!bInTags){
								iOptsCount++;
								let tag = {name: `${element.tagText}: ${element.value}`, param_id: element.param_id};
								if(element.elementType == 'input-range'){
									let strText = '';
									if(!this.$GVO.isEmpty(element.value.min)){
										strText += 'от '+element.value.min;
									}
									if(!this.$GVO.isEmpty(element.value.max)){
										strText += ' до '+element.value.max;
									}
									tag = {name: `${element.tagText}: ${strText}`, param_id: element.param_id};
								} else if(element.elementType == 'checkbox'){
									if(element.value == true){
										tag = {name: element.tagText, param_id: element.param_id};
									}else{
										tag = null;
									}
								} else if(element.elementType == 'select-objcat'){
									let strText = '';
									if(!this.$GVO.isEmpty(element.value.houseTypeList)){
										strText = element.value.houseTypeList;										
										//console.log(element.value.houseTypeList,this.cat_objects_category);
										for (let icat = 0; icat < this.cat_objects_category.length; icat++) {
											if(element.value.houseTypeList === this.cat_objects_category[icat].value){
												//console.log(this.cat_objects_category[icat].label);
												strText = this.cat_objects_category[icat].label;	
											}
										}
									}
									if(!this.$GVO.isEmpty(element.value.houseRoomsList)){
										// strText += ' , '+element.value.houseRoomsList;
										// console.log(element.value.houseRoomsList);
										for (let ihroom = 0; ihroom < element.value.houseRoomsList.length; ihroom++) {
											for (let jcat = 0; jcat < this.cat_objects.length; jcat++) {
												if(element.value.houseRoomsList[ihroom] === this.cat_objects[jcat].value){
													strText += ' , '+this.cat_objects[jcat].label;	
													// console.log(this.cat_objects[jcat].label);
												}
											}
										}
									}
									tag = {name: `${element.tagText}: ${strText}`, param_id: element.param_id};
								} else if(element.elementType == 'select'){
									// console.log(element,typeof element.value);
									let strText = '';
									for (let iSel = 0; iSel < element.options.length; iSel++) {
										// console.log(element, element.value);
										if(typeof element.value == 'string' && element.value.indexOf(',')!=-1) element.value = element.value.split(',');
										if (typeof element.value == 'object') {
											for (let iv = 0; iv < element.value.length; iv++) {
												if(element.options[iSel].value == element.value[iv]) strText += element.options[iSel].label+';';
											}
										}else{
											if(element.options[iSel].value == element.value) strText = element.options[iSel].label;
										}
									}
									tag = {name: `${element.tagText}: ${strText}`, param_id: element.param_id};
									// tag = {name: `${element.tagText}: ${strText.slice(0, -1)}`, param_id: element.param_id};
								} else if(element.elementType == 'input-hidden-mdgd'){
									let strText = this.translateTags({selectedType: element.param_id});
									tag = {name: `${element.tagText}: ${strText}`, param_id: element.param_id};
								} else if(element.elementType == 'fromSubway'){
									let strText = '';
									if(element.value.dWayTypeFromMetro == '0'){
										strText = 'пешком';
									}else{
										strText = 'на транспорте';
									}
									tag = {name: `${element.tagText}: ${strText} ${element.value.dTimeFromMetro} мин`, param_id: element.param_id};
								}
								else if(element.elementType == 'ajax-list-client'){
									let strText = '';
									if(element.value.agent_id != ''){
										strText = 'агент ';
										strText += this.translateTags({selectedType: element.elementType});
									}
									if(element.value.otdel_id != ''){
										//console.log(element.value.otdel_id);
										var masRetTree = [];
										/* Ищет рекурсивно по массиву, параетры 1-дерево для поиска, 2-название своства в узле дерева, 3-его значение, 4-куда отдать результат */
										this.$GVO.SeachTreeReq(this.$GVO.masTreeOrgStruct,'id',element.value.otdel_id,masRetTree);
										//console.log(masRetTree);
										strText = typeof masRetTree[0].name!='undefined'?masRetTree[0].name:'отдел '+element.value.otdel_id;

									}
									if(element.value.isFired != ''){
										strText += ' с уволенными';
									}
									tag = {name: `${element.tagText}: ${strText}`, param_id: element.param_id};
								} 
								if(tag != null ) this.filterTags.push(tag);
							}						
						}
					}
				}
				this.optCount = iOptsCount;
			} else {
				this.optCount = '';
				this.filterTags = [];
			}
		},
		getFilterDataElement(strKey){
			if (this.objFilterData.hasOwnProperty(strKey)){
				this.objFilterData[strKey].param_id = strKey;
				return this.objFilterData[strKey];
			} else if(strKey == 'dfloorfrom' || strKey == 'dfloorto' || strKey == 'livingSpacemin' || strKey == 'livingSpacemax' || strKey == 'areamin' || strKey == 'areamax' || strKey == 'kitchenSpacemin' || strKey == 'kitchenSpacemax' || strKey == 'pricemin' || strKey == 'pricemax' ||  strKey == 'houseStartYearmin' || strKey == 'houseStartYearmax'){ 
				// установка параметров в компонент "отдо" ReInputRange
				for (const keyInFlt in this.objFilterData) {
					if (this.objFilterData.hasOwnProperty(keyInFlt) && this.objFilterData[keyInFlt].elementType=='input-range') {
						if ( (typeof this.objFilterData[keyInFlt].map_min != 'undefined' && this.objFilterData[keyInFlt].map_min == strKey) || (typeof this.objFilterData[keyInFlt].map_max != 'undefined' && this.objFilterData[keyInFlt].map_max == strKey) ) {
							this.objFilterData[keyInFlt].param_id = Object.keys(this.objFilterData).find(key => this.objFilterData[key] === this.objFilterData[keyInFlt]);
							return this.objFilterData[keyInFlt];
						}
					}
				}
			} else if(strKey == 'dWayTypeFromMetro' || strKey == 'dTimeFromMetro'){
				this.objFilterData['fromSubway'].param_id = 'fromSubway';
				return this.objFilterData['fromSubway'];
			} else if(strKey == 'agent_id' || strKey == 'otdel_id' || strKey == 'isFired'){
				this.objFilterData['structure'].param_id = 'structure';
				return this.objFilterData['structure'];
			}
		},
		ShowFilter(){
			this.bShowFilter = !this.bShowFilter;
		},
		SetFilterParams(){ // загружает значения в фильтр из ГЕТ строки
			for (const key in this.objGetParams) {
				if (this.objGetParams.hasOwnProperty(key)) {
					let element = this.getFilterDataElement(key);
					//console.log(key,element);
					if (this.objFilterData.hasOwnProperty(key)) {
						if(this.objGetParams[key] != '' && this.objGetParams[key] != '[object Object]'){
							if(key == 'ddecoration' || key == 'dbanks' || key == 'cellId' || key == 'buildingType'){
								this.objFilterData[key].value = this.objGetParams[key].split(';');
							} else {
								if(element.elementType == 'input-hidden-mdgd'){
									this.objFilterData[key].value = this.objGetParams[key];
								}else if(element.elementType == 'select-objcat'){
									//console.log(this.objGetParams[key]);
									this.objFilterData[key].value = JSON.parse(this.objGetParams[key]);
								} else {
									if (typeof this.objFilterData[key].value == 'boolean') {
										this.objFilterData[key].value = parseInt(this.objGetParams[key])==0?false:true;
										
									} else {
										this.objFilterData[key].value = this.objGetParams[key];
										
									}
								}
							}
						}
					} else if(typeof element !='undefined' && element.elementType == 'input-range'){
						for (const keyInFlt in this.objFilterData) {
							if (this.objFilterData.hasOwnProperty(keyInFlt)) {
								if (typeof this.objFilterData[keyInFlt].map_min != 'undefined' && this.objFilterData[keyInFlt].map_min == key) {
									this.objFilterData[keyInFlt].value.min = this.objGetParams[key];
								}
								if (typeof this.objFilterData[keyInFlt].map_max != 'undefined' && this.objFilterData[keyInFlt].map_max == key) {
									this.objFilterData[keyInFlt].value.max = this.objGetParams[key];
								}
							}
						}
					} else if(key == 'dWayTypeFromMetro' || key == 'dTimeFromMetro'){
						this.objFilterData['FromMetro'].value[key] = this.objGetParams[key];
					}else if(key == 'agent_id' || key == 'otdel_id' || key == 'isFired'){
						//console.log('structure '+key);
						this.objFilterData['structure'].value[key] = this.objGetParams[key];
					}
				}
			}
			this.OnFilterApply();
		},
		ApplyFilterParams(){ // подготавливает значения из фильтра для ГЕТ строки
			for (const key in this.objFilterData) {
				if (this.objFilterData.hasOwnProperty(key)) {
					let element = this.getFilterDataElement(key);
					if(element.elementType == 'input-range'){
						if(typeof this.objFilterData[key].map_min != 'undefined' && this.objFilterData[key].map_min != ''){
							if(!this.$GVO.isEmpty(this.objFilterData[key].value.min)){
								this.objGetParams[this.objFilterData[key].map_min] = this.$GVO.str_replace(' ','',this.objFilterData[key].value.min);
							}
						}
						if(typeof this.objFilterData[key].map_max != 'undefined' && this.objFilterData[key].map_max != ''){
							if(!this.$GVO.isEmpty(this.objFilterData[key].value.max)){
								this.objGetParams[this.objFilterData[key].map_max] = this.$GVO.str_replace(' ','',this.objFilterData[key].value.max);
							}
						}

						if(this.$GVO.isEmpty(element.value.min)) delete this.objGetParams[element.map_min];
						if(this.$GVO.isEmpty(element.value.max)) delete this.objGetParams[element.map_max];
					}else if(element.elementType == 'checkbox'){
						if(element.value === true){
							this.objGetParams[key] = this.objFilterData[key].value===true?1:0;
						}else{
							if(key != 'dnotworkgk'){
								delete this.objGetParams[key];
							}else{
								this.objGetParams[key] = this.objFilterData[key].value===true?1:0;
							}
						}
					}else if((key == 'ddecoration' || key == 'dbanks' || key == 'cellId' || key == 'buildingType') && this.objFilterData[key].value.length > 0){
						this.objGetParams[key] = this.objFilterData[key].value.join(';');
					}else if(element.elementType == 'select-objcat'){
						//JSON_houseType:{value:{houseTypeList:'',houseRoomsList:'', }, tagText:'Тип жилья', elementType: 'select-objcat', value_default:{houseTypeList:'',houseRoomsList:'',}},
						//console.log(this.objFilterData[key].value);
						if(this.objFilterData[key].value.houseTypeList != ''){
							this.objGetParams[key] = JSON.stringify(this.objFilterData[key].value);
						} else delete this.objGetParams['JSON_houseType'];						
					}else if(element.elementType == 'fromSubway'){
						if(typeof this.objFilterData[key].value.dTimeFromMetro != 'undefined' && this.objFilterData[key].value.dTimeFromMetro != ''){
							this.objGetParams['dTimeFromMetro'] = this.objFilterData[key].value.dTimeFromMetro;
							if(typeof this.objFilterData[key].value.dWayTypeFromMetro == 'undefined' || this.objFilterData[key].value.dWayTypeFromMetro == ''){
								this.objFilterData[key].value.dWayTypeFromMetro == '0';
							}
							this.objGetParams['dWayTypeFromMetro'] = this.objFilterData[key].value.dWayTypeFromMetro;
						}else{
							delete this.objGetParams['dWayTypeFromMetro'];
							delete this.objGetParams['dTimeFromMetro'];
						}
					}else if(element.elementType == 'ajax-list-client'){ // if(key == 'agent_id' ||key == 'otdel_id' ||key == 'isFired'){
						if(typeof this.objFilterData.structure.value.agent_id != 'undefined' && this.objFilterData.structure.value.agent_id != ''){
							this.objGetParams['agent_id'] = this.objFilterData.structure.value.agent_id;
						} else {
							delete this.objGetParams['agent_id'];
						}
						if(typeof this.objFilterData.structure.value.otdel_id != 'undefined' && this.objFilterData.structure.value.otdel_id != ''){
							this.objGetParams['otdel_id'] = this.objFilterData.structure.value.otdel_id;
						} else {
							delete this.objGetParams['otdel_id'];
						}
						if(typeof this.objFilterData.structure.value.isFired != 'undefined' && this.objFilterData.structure.value.isFired != ''){
							this.objGetParams['isFired'] = this.objFilterData.structure.value.isFired;
						} else {
							delete this.objGetParams['isFired'];
						}
					}else{
						if(!this.$GVO.isEmpty(this.objFilterData[key].value) || this.objFilterData[key].value == '[object Object]'){
							this.objGetParams[key] = this.objFilterData[key].value;
						}else{
							delete this.objGetParams[key];
						}
					}
				}
			}
			this.bShowFilter = false;
		},
		OnFilterApply(){ // применяет параметры из фильтра и запускает запрос к АПИ
			// console.log('OnFilterApply in filter',this.$GVO.GetAllGet());
			// this.objGetParams = this.$GVO.GetAllGet();
			// console.log('OnFilterApply in filter',this.objGetParams);

			if(typeof this.$GVO.GetAllGet().dSearchType !='undefined' && this.objFilterData.dSearchType.value != this.$GVO.GetAllGet().dSearchType) {
				this.objFilterData.dSearchType.value = this.$GVO.GetAllGet().dSearchType;
			}
			if(typeof this.$GVO.GetAllGet().task_id !='undefined') {
				//без этого блока, при сбрасывании фильтра через тег "Сбросить всё", обнуляться эти параметры по задачам -- они важны при выполнении задачи с презентациями
				this.objGetParams.task_id = this.$GVO.GetAllGet().task_id;
				this.objGetParams.taskend_id = this.$GVO.GetAllGet().taskend_id;
				this.objGetParams.client_id = this.$GVO.GetAllGet().client_id;
				this.objGetParams.service_id = this.$GVO.GetAllGet().service_id;
			}
			
			if(typeof this.objGetParams['show_pres'] != 'undefined') delete this.objGetParams['show_pres'];
			if(this.objGetParams['JSON_houseType'] == '[object Object]') { delete this.objGetParams['JSON_houseType'];}
			// console.log('OnFilterApply in filter',this.objGetParams);

			this.ApplyFilterParams();
			//console.log(this.objGetParams);
			this.setOptCount(this.objGetParams);
			// console.log('запускается в самом фильтре, это objGetParams,this.objGetParams',this.objGetParams);
			if(location.search.substr(1) != this.$GVO.ObjToQueryString(this.objGetParams).substr(1)){
				this.$emit('change',this.$GVO.ObjToQueryString(this.objGetParams).substr(1));
			}

		},
		OnFilterReset(){

			if(typeof this.objGetParams.task_id != 'undefined'){
				let dmp_objGetParams = {'task_id':'','taskend_id':'','client_id':'','service_id':''};
				dmp_objGetParams.task_id = this.$GVO.unlinkObject(this.objGetParams.task_id);
				dmp_objGetParams.taskend_id = this.$GVO.unlinkObject(this.objGetParams.taskend_id);
				dmp_objGetParams.client_id = this.$GVO.unlinkObject(this.objGetParams.client_id);
				dmp_objGetParams.service_id = this.$GVO.unlinkObject(this.objGetParams.service_id);
				this.objGetParams = {};
				this.objGetParams =  this.$GVO.unlinkObject(dmp_objGetParams);
				// console.log('OnFilterReset dmp_objGetParams', dmp_objGetParams);
				// console.log('OnFilterReset objGetParams', this.objGetParams);
			}else{
				this.objGetParams = {};
			}

			this.objGetParams = {};
			for (const key in this.objFilterData) {
				if (this.objFilterData.hasOwnProperty(key) && this.masExcludeParams.indexOf(key) == -1) {
					this.objFilterData[key].value = this.$GVO.SafeParseJson(JSON.stringify(this.objFilterData[key].value_default));
				}
			}
			this.OnFilterApply();
		},
		SetCats(strCat){
			for (const key in this.objFilterData) {
				if (this.objFilterData.hasOwnProperty(key)) {
					if(typeof this.objFilterData[key].catalog != 'undefined' && this.objFilterData[key].catalog == strCat){
						this.objFilterData[key].options = this.$GVO.getCatToSelect(this.objFilterData[key].catalog);
					}
				}
			}
		},
		OnAjaxListSearch(opt){

		},
		setCatCategoryObj(){
			// console.log(this.$GVO.cats.cat_objects_category);
			this.cat_objects_category = [];
			this.cat_objects = [];
			for (let i = 0; i < this.$GVO.cats.cat_objects_category.length; i++) {
				this.cat_objects_category.push({'value':this.$GVO.cats.cat_objects_category[i].id.toString(),'label':this.$GVO.cats.cat_objects_category[i].name});
			}
			for (let i = 0; i < this.$GVO.cats.cat_objects.length; i++) {
				this.cat_objects.push({'value':this.$GVO.cats.cat_objects[i].id.toString(),'label':this.$GVO.cats.cat_objects[i].name});
			}
			
		},
		doEnterThings(e,dopParam) {
			this.OnFilterApply();	
			// console.log("enter was pressed on page ", location.pathname);
		},
	},
	mounted() {

		
		
		this.$GVO.ApiCall('cat.GET_CELLS_CAT',{flt:{}})
		.then((objApi) => {
			if(objApi.success === true){
				if(objApi.data.length > 0){
					this.objFilterData.cellId.options = objApi.data;
					// this.cellIdOptions = objApi.data;
					
				}
			}
		}).catch(errorObjApi => {console.error(errorObjApi);});
		
		this.objGetParams = this.$GVO.GetAllGet();

		

		//console.log(this.$GVO.GetAllGet());
		this.$GVO.LoadCatPromise('cat_objects_source').then((ret)=>{
			this.SetCats('cat_objects_source');
			this.SetFilterParams();
			
			if((typeof this.$GVO.my_profile != 'undefined' && typeof this.$GVO.my_profile.is_boss != 'undefined') || (this.$GVO.my_profile.ObjModerator!=0)){
				if(this.$GVO.my_profile.is_boss!==0 || this.$GVO.my_profile.ObjModerator!=0){
					if(this.objFilterData.structure.rb_options.length==2){
						this.objFilterData.structure.rb_options.push({'name': '2', 'label': 'Объекты сотрудника'});
						this.objFilterData.structure.rb_options.push({'name': '3', 'label': 'Объекты отдела'});
						// this.objFilterData.structure.rb_options.push({'name': '4', 'label': 'Объекты уволенных'}); //12.04.24 Артем: если увольняется сотрудник, все его услуги перемешиваются на руководителя автоматом	
					}
				}
			}
		}).catch(errorRet => console.error(errorRet));

		
		this.$GVO.LoadCatPromise('cat_objects_category')
		.then((objApi) => {		
			if(objApi === true){
				this.$GVO.LoadCatPromise('cat_objects')
					.then((objApi) => {		
						if(objApi === true){
							this.setCatCategoryObj();
							this.SetFilterParams();
						}
					}).catch(errorObjApi => {console.error(errorObjApi);});
			}
		}).catch(errorObjApi => {console.error(errorObjApi);});
		
	}
};
</script>
<style scoped>
.majorFilter-card {border: 1px solid #01b0e0;}
.majorFilter {display: flex; justify-content: space-between;}
.firstFilter-row {display: flex; flex-wrap: wrap; width: 100%;}
.filter-shown {display: block;}
.filter-hidden {display: none;}
.map-search .btn {margin-top: 0px; width: 207px; padding-left: 5px;}
.allFilters {justify-content: flex-end;}
.allFilters .btn, .applyFilter .btn {margin-top: 0px; margin-right: 15px;}
/* .id-search {max-width: 200px;} */

.ssopage >>> .el-select .el-input.is-focus .el-input__inner:focus {border: 1px solid #01B0E0;}

.map-search >>> .btn.btn-simple {border-color: #2b3553; color: rgba(255, 255, 255, 0.8); font-weight: 400;}
.white-content .map-search >>> .btn.btn-simple {color: #6062667c;}
.map-search >>> .btn.btn-simple:hover {border-color: #01b0e0; color: rgba(1, 176, 224, 0.6); font-weight: 400;}
.ssopage >>> .form-group input:hover, .input-group:hover {border: 1px solid #01b0e0;}

.ssopage >>> .el-select .el-input.is-focus .el-input__inner:hover, .el-input .el-input--large .el-input--suffix:hover {border: 1px solid #01b0e0; }
.ssopage >>> .el-input .el-input--large .el-input--suffix .is-focus {border: 1px solid #01b0e0;}
.ssopage >>> .el-select .el-input.is-focus .el-input__inner  {border: 1px solid #01b0e0;}
.ssopage >>> .el-select__input .is-large:hover > .select-primary.el-select .el-input input {border: 1px solid #01b0e0;}
/*HOVER FOR .el-icon-circle-colse*/
.ssopage >>> .el-input__suffix-inner:hover i {font-size: 20px; color: #F84E54;}

/*.ReInputSearchDropType:hover {border: 1px solid #01b0e0; border-radius: 6px;}*/
/*.ReInputSearchDropType:hover {margin-bottom: 0; border: 1px solid #01b0e0; border-radius: 6px;}*/
.moreFilter >>> .el-select .el-input .el-input__icon:hover {font-size: 24px; color: #F84E54;}

.ssopage >>>  .dropdown-menu .tim-icons {margin-top: -10px;}
.flat-corp-row, .filter-row {display: flex; flex-wrap: wrap;}

.ssopage >>> .outline-secondary {border-right: 1px solid #2b3553}
.ssopage >>> .outline-secondary:hover {border: 1px solid #01B0E0;}
.ssopage >>> .outline-secondary:focus {border-right: 1px solid #01B0E0; border-left: 1px solid #01B0E0;}
.ssopage >>> .flat-corp-row .form-control:hover, .input-group-text:focus {border: none;}
.ssopage >>> .flat-corp-row .input-group:hover {border: 1px solid #01B0E0; border-radius: 6px;}
.ssoModuleScndFilter >>> hr {border-top: 1px solid #01B0E0!important;}
.ssoModuleScndFilter >>> .el-select .el-input.is-focus .el-input__inner:focus {border: 1px solid #01B0E0;}

.sLabelText label {font-size: .9rem;}
.allFilters .btn {margin-bottom: 10px;}

.majorFilter-card >>> .el-select .el-input__inner {height: 38px;}
.ssoModuleScndFilter .ReSelectCascade {display: flex;flex-direction: row;}
.ssoModuleScndFilter >>> .ReSelectCascade .row {margin-right: 1px!important;}

@media (max-width: 768px) {	
	.map-search, .year-search, .type-search, .price-search, .base-search, .flat-corp-width, .id-search {margin-right: 0px !important; width: 100%;}
	.map-search .btn.btn-simple {width: 100%;}
	.majorFilter-card >>>  .overflow-overlay {max-height: 110px!important;}
}
@media (max-width: 575px) {
	.filter-row > .col-md-4, .filter-row > .col-sm-6 {padding-right: 0px;}
	.applyFilter, .allFilters, .allFilters .btn, .applyFilter .btn {width: 100%;}
	.type-search {margin-bottom: 20px !important;}
}



</style>
